import { tryExecution } from '../_util';
import { setFloatingContactVisible } from './_floatingContactIcon';
import { smoothScrollTo } from './_common';

const baseClass = 'header__contact';
const contactFormId = 'kontaktformular';

class ContactIcon {
  /**
   * @param {HTMLElement} element
   */
  constructor(element) {
    this.element = element;
    this.link = this.element.getElementsByTagName('a')[0];

    this.attachEvents();
  }

  attachEvents() {
    if (this.link == null) {
      return;
    }

    if (this.link.dataset.locationSubpage != null && this.link.dataset.locationSubpage === "true") {
      this.element.addEventListener('click', this.handleContactClick.bind(this));
    }
  }

  handleContactClick(event) {
    const contactForm = document.getElementById(contactFormId);
    if (contactForm == null && setFloatingContactVisible(true)) {
        event.preventDefault();
        event.stopPropagation();

        return;
    }

    if (contactForm) {
      event.preventDefault();
      event.stopPropagation();

      window.location.hash = contactFormId;
      setTimeout(() => {
        smoothScrollTo(contactForm, 750);
      }, 50);

      return;
    }
  }
}

function init() {
  for (const element of document.getElementsByClassName(baseClass)) {
    tryExecution(() => new ContactIcon(element));
  }
}

export default {
  init,
}
